import classNames from 'classnames';
import { useState } from 'react';

import { SpineIcon } from '@/components/icon';
import { RenameType } from '@/interface/library';
import { CgiErrorCode } from '@/services/cgi';
import { UserResourceDetail } from '@/services/library';
import { useAppDispatch } from '@/store';
import { changeId } from '@/store/modules/library';

import Rename from '../rename';
import LibrarySpineViewer from '../review/spine';
import { NameLength } from './image';
import styles from './index.module.less';

interface IProps {
  value: UserResourceDetail;
  resourceName: string;
  checked: boolean;
  disabled: boolean;
  handleCheckedChange: (check: boolean) => void;
  updateResource: (value: UserResourceDetail) => void;
  reNameCallback: (info: UserResourceDetail) => void
}
const SpineItem: React.FC<IProps> = (props) => {
  const {
    resourceName, checked,
    value, disabled,
    handleCheckedChange,
    reNameCallback,
  } = props;
  const dispatch = useAppDispatch();

  const spliceName = resourceName.slice(0, NameLength);
  const name = resourceName?.length > NameLength ? `${spliceName}...` : spliceName;
  const [visible, setVisible] = useState(false);

  const changeVisible = (vi: boolean) => {
    if (vi) {
      dispatch(changeId({ id: value.resourceId }));
    }
    setVisible(vi);
  };

  const handleStopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
  };


  const reName = (code: CgiErrorCode, info: {
    name: string, id: string
  }) => {
    if (code === CgiErrorCode.NO_ERROR) {
      reNameCallback({ ...value, resourceName: info.name });
    }
  };

  return (
    <div className={classNames(styles.item, {
      [styles.checked]: checked,
    })}>
      <LibrarySpineViewer
        value={value}
        checked={checked}
        onCheckedChange={check => handleCheckedChange(check)}
      />
      <div className={styles.fileName} onClick={handleStopPropagation}>
        {
          visible
            ? <Rename
              resourceName={resourceName}
              type={RenameType.TYPE_RENAME_RESOURCE}
              id={value.resourceId || ''}
              visible={visible}
              callBack={reName}
              changeVisible={changeVisible}
            /> : <>
              <SpineIcon /><span className={styles.name}>{name}</span>
              {
                disabled ? null : <span className={styles.edit}>
                  <Rename
                    resourceName={resourceName}
                    type={RenameType.TYPE_RENAME_RESOURCE}
                    id={value.resourceId || ''}
                    visible={visible}
                    changeVisible={changeVisible}
                  />
                </span>
              }
            </>
        }
      </div>
    </div>
  );
};

export default SpineItem;
